import { createBrowserRouter, useLoaderData } from "react-router-dom";
import ErrorPage from "../Components/ErrorPage";
import Login from "../Components/Login/Login";
import MainOutlet from "../Components/MainOutlet";
import AllNews from "../Components/News/AllNews/AllNews";
import PrivateComponent from "../Components/PrivateComponent";
import SignUp from "../Components/SignUp/SignUp";

export const routers = createBrowserRouter([
  {
    path: '/',
    element: <MainOutlet></MainOutlet>,
    children: [
      {
        path: '/',
        loader: () =>{
          return  fetch('http://localhost:5000/news')
        },
        element: <AllNews></AllNews>
      },
      {
        path:'/news',
        loader: () =>{
          return  fetch('http://localhost:5000/news')
        },
        element: <AllNews></AllNews>
      },
      {
        path:'/news/:newsId',
        loader: ({params}) =>{
          return  fetch(`http://localhost:5000/news/${params.newsId}`)
        },
        element: <PrivateComponent><AllNews></AllNews></PrivateComponent>
      },
      {
        path:'*',
        element: <ErrorPage></ErrorPage>
      },
    ]
  },
  {
    path:'*',
    element: <ErrorPage></ErrorPage>
  },
  {
    path: '/login',
    element: <Login></Login>
  },
  {
    path:'/register',
    element: <SignUp></SignUp>
  },
])